<template>
    <div class="trz_leave_settings">
        <div class="row mt-4">
            <div class="col-sm-8">
                <div class="card h-100">
                    <div class="card-header d-none">
                        <div class="float-right"><b-button type="submit" variant="primary">Set default holidays for next year</b-button> </div>

                    </div>
                    <div class="card-body">
                        <div>Select Day / Range</div>
                        <div class="row">                            
                            <div class="col-sm-6">From<b-form-datepicker id="holiday_one" @context="updateToDate()"  v-model="holiday_one" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>
                            <div class="col-sm-6">To <b-form-datepicker id="holiday_two" :min="holiday_one"  v-model="holiday_two" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>
                            
                        </div>
                        <div class='row mt-2'>   

                            
                            <div class="col-sm-6">
                                <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                                    <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                                    <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                                </b-form-group>
                                <div class="clearfix">
                                    <div class="float-left"><b-button variant="success" @click="saveHoliDays()">Save</b-button></div>   
                                    <div class="float-right font-italic">Day(s) : {{dateDiff}}</div>   
                                </div>
                            </div>                                
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="card h-100">
                    <div class="card-header">
                        List of Approved Holidays: 
                        <b-form-select id="year" name="year" v-model="year" :options="year_options" @change="getHoliDays"></b-form-select>
                    </div>
                    <div class="card-body " style="height:300px; overflow-y:scroll;">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item" v-for="holiday in holidays" :key="holiday.id">
                                <div class="cursor-pointer" :title="holiday.comment" v-b-tooltip placement="right" v-if="checkGaterDate(holiday.leave_date)" @click="updateHoliday(holiday.id)">
                                    {{formatdate(holiday.holiday_date)}}
                                    
                                    - {{holiday.comment}}

                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-holiday"  hide-footer v-bind:title="holiday.holiday_date">
            <b-form @submit.stop.prevent="onSubmitHolidayUpdate">
                <input type="hidden" v-model="holiday.id" name="id">
                
                <b-form-group id="holiday_date-group" label="Date" label-for="holiday_date">
                    <b-form-datepicker id="holiday_date" v-model="holiday.holiday_date" show-decade-nav ></b-form-datepicker>
                </b-form-group>

                <b-form-group id="comment_update-group" label="Reason/Comment" label-for="comment_update">
                    <b-form-textarea id="comment_update" name="comment" rows="3" max-rows="6" no-resize v-model="holiday.comment"  ></b-form-textarea>
                </b-form-group>

                <b-button type="submit" variant="success">Submit</b-button> 

            </b-form>
        </b-modal>

    </div>
</template>
<script>    
    
    import moment from 'moment'

    export default{
        
        mounted() {
            
        },
        props: [],   
        components: {
            
        },     
        data(){
            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/
            const startdate = minDate

            return {
                min: minDate,
                //max: maxDate,
                holiday_one:startdate , holiday_two:startdate,
                fdata : {id:0, holiday_one:startdate , holiday_two:startdate, days:null , comment:null},
                holiday : {},

                start_date : startdate,

                holidays : [],
                
                year : now.getFullYear(),
                year_options : [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],
                
            }
        },
        methods:{

            updateToDate:function()
            {
                this.holiday_two = this.holiday_one;
            },            
            formatdate:function(x) 
            {
                return moment(x).format('YYYY-MM-DD');
            },
            checkGaterDate(x)
            {
                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            updateHoliday : function(x)
            {
                axios.get(this.$api_url+'/government/holiday?id='+x , {
                    params: {
                        //id: x
                    }
                }).then(function(response){                  
                    this.holiday = response.data;
                    
                }.bind(this));
                this.$bvModal.show('bv-modal-holiday');
            },
            onSubmitHolidayUpdate:function()
            {
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.holiday)) 
                {                    
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);                    
                    console.log(`${key}: ${value}`);
                } 
                axios.post(this.$api_url+'/government/holiday', formData,)
                            .then(function (response) 
                            {                             
                                if(response.data.status)
                                {
                                    //this.holidays = response.data.holidays;
                                    this.getHoliDays();
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                    this.$bvModal.hide('bv-modal-holiday');
                                }
                                else
                                {
                                    this.$bvToast.toast(response.data.message, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        }); 
                                }
                                
                                
                            }.bind(this))
                            .catch(function (error) 
                            {                                    
                                currentObj.serverError(error);
                            });
            },
            getHoliDays:function() 
            {   
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/government/holidays/list?year='+this.year , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.holidays = response.data.holidays;
                    }       
                    
                }.bind(this));

            },
            saveHoliDays:function()
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        console.log(`${key}: ${value}`);
                    } 
                    axios.post(this.$api_url+'/government/holidays', formData,)
                                .then(function (response) 
                                {                             
                                    if(response.data.status)
                                    {
                                        //this.holidays = response.data.holidays;
                                        this.getHoliDays();
                                        this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            }); 
                                        
                                        this.fdata.id = 0;
                                        this.holiday_one = this.startdate;
                                        this.holiday_two =  this.startdate;
                                        
                                        this.fdata.comment = null;
                                       
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                                title: `Warning`,
                                                variant: 'warning',
                                                solid: true
                                            }); 
                                    }
                                    
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                });
            
                });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            fetchDateDisabled()
            {                
                return this.week_holidays;
            }
        },
        created: function(){
            
            this.getHoliDays();
        },
        computed: 
        {
            dateDiff()
            {
                //fdata : {holiday_one:null , holiday_two:null, days:null , details:null},
                
                var holiday_one = moment(this.holiday_one);
                var holiday_two = moment(this.holiday_two);  

                this.fdata.holiday_one = moment(String(this.holiday_one)).format('YYYY-MM-DD');
                this.fdata.holiday_two = moment(String(this.holiday_two)).format('YYYY-MM-DD');

                if(this.holiday_one === this.holiday_two)
                {
                    this.fdata.days = 1;
                    return 1;
                }
                let days = holiday_two.diff(holiday_one, 'days') // 1

                if(days > 0)
                {
                    ++days;
                    this.fdata.days = days;
                    return days;
                }                   
                else if(days < 0)
                {
                    this.fdata.days = 0;
                    return 'Invalid Date Range';
                }
                    
            },
            fetchStartWeekday()
            {
                return this.week_start_day;
            },
            
        }
    }
</script>
